import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { useState } from "react";
import { ColDef } from "ag-grid-community";
import { saveGridColumnLayout } from "../columnLayoutPersistence";

function isLeftSide(colDef: ColDef, columnDefs: ColDef[]) {
  const index = columnDefs.indexOf(colDef);
  return index >= 0 && index < Math.floor(columnDefs.length / 2); // Check for left half
}

const DisplayColMenuItem = ({ colDef, columnApi, columnDefs, layoutScope }) => {
  let pinnedState = isLeftSide(colDef, columnDefs) ? "left" : "right";
  const columnId = colDef.colId || colDef.field;

  let isPinned = colDef.pinned != false && colDef.pinned != undefined;
  const [pinned, setPinned] = useState(isPinned);


  return (
    <MenuItem
      onClick={() => {
        if (!columnId) {
          return;
        }

        let nowPinned = colDef.pinned == false || colDef.pinned == undefined;
        setPinned(nowPinned);
        columnApi.setColumnPinned(columnId, nowPinned ? pinnedState : null);
        saveGridColumnLayout(columnApi, layoutScope);
      }}
    >
      <input type="checkbox" checked={pinned} readOnly></input>
      {colDef.headerName}
    </MenuItem>
  );
};

export default DisplayColMenuItem;
